import { LANDING_FLOW_STORAGE_KEY, type LandingFlowData, LandingFlowDataSchema } from './types';

export const landingFlowEnabled = (): boolean => {
  return sessionStorage.getItem(LANDING_FLOW_STORAGE_KEY) !== null;
};

export const saveLandingFlow = (data: LandingFlowData): void => {
  sessionStorage.setItem(LANDING_FLOW_STORAGE_KEY, JSON.stringify(data));
};

export const consumeLandingFlow = (): LandingFlowData | null => {
  const raw = sessionStorage.getItem(LANDING_FLOW_STORAGE_KEY);
  sessionStorage.removeItem(LANDING_FLOW_STORAGE_KEY);

  if (!raw) return null;

  try {
    const parsedData = LandingFlowDataSchema.safeParse(JSON.parse(raw));
    return parsedData.success ? parsedData.data : null;
  } catch {
    return null;
  }
};

const LANDING_PROGRESS_FLOOR_KEY = 'landing_progress_floor';

export const saveLandingProgressFloor = (percent: number): void => {
  sessionStorage.setItem(LANDING_PROGRESS_FLOOR_KEY, String(percent));
};

export const peekLandingProgressFloor = (): number => {
  const val = sessionStorage.getItem(LANDING_PROGRESS_FLOOR_KEY);
  return val ? Number(val) : 0;
};

export const consumeLandingProgressFloor = (): number => {
  const val = sessionStorage.getItem(LANDING_PROGRESS_FLOOR_KEY);
  sessionStorage.removeItem(LANDING_PROGRESS_FLOOR_KEY);
  return val ? Number(val) : 0;
};
